import React from 'react';
import './contacts.css';

export default function Contacts() {
  return (
    <section id="Contact">
        <div className="contact--container">
            <h1>Contact</h1>
            <div className="contact--data">
                <div className="contact--card">
                    <h4>e-mail</h4>
                    <ul>
                        <li>
                            <a href="mailto:davidpiredda@me.com" className="mail_text mt-3"><i className="bi bi-envelope link--icons"></i>Send an email</a>
                        </li>
                    </ul>
                </div>
                <div className="contact--card">
                    <h4>social</h4>
                    <ul>
                        <li>
                            <a href="https://www.linkedin.com/in/davidpiredda/" target='_blank' rel="noreferrer"><i className="bi bi-linkedin link--icons"></i>LinkedIn</a>
                        </li>
                        <li>
                            <a href="https://github.com/dpdproject" target='_blank' rel="noreferrer" ><i className="bi bi-github link--icons"></i>GitHub</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </section>
  )
}
